import { Permissions } from "../../../models/enums/permissions";
import { ValidateProperty } from "../../../models/utilities/validate-property";

export class UserUpdate {
    
    /** What the user holds, by service center */
    public permissions : { [serviceCenter: string]: Permissions[] } = {};
    
    @ValidateProperty({ required: true })
    public rowVersion : string = '';

}
